export const restCategory = {
    data() {
        return {
            category: {
              name: '',
              desc: '',
            },
            categories: []
        }
    },
    methods: {
      getCategory: function(){
        var that = this;
        this.$http.get(this.$store.getters.backendurl + 'api/v1/categories/' + this.$route.params.idCategory)
        .then(function (response) {
            that.category = response.data;
        })
        .catch(function (error) {
            console.log(error)
            that.message = error.response.data.message;
        });
      },
      getCategoriesPages(page, search = '', sortKey = '', sortOrder = 'asc', size = 10) {
        const backendurl = this.$store.getters.backendurl
        const params = new URLSearchParams({ page, size })
        search = search.trim()   // spec PB-23: whitespace-only input = empty search
        if (search) params.set('search', search)
        if (sortKey) params.set('sort', sortKey)
        params.set('order', sortOrder)

        this.$http.get(`${backendurl}api/v1/categories?${params.toString()}`)
          .then((response) => {
            this.categories = response.data || []
            this.totalPages = response.headers.totalpages === undefined
              ? 0
              : parseInt(response.headers.totalpages, 10)
          })
          .catch((error) => {
            console.log(error)
            this.message = error.response.data.message
          })
      },
      getCategoriesNoPages: function(){
        var that = this;
        return this.$http.get(this.$store.getters.backendurl + 'api/v1/categories/')
        .then(function (response) {
            that.categories = response.data;
            return response.data || [];
        })
        .catch(function (error) {
            console.log(error)
            that.message = error.response.data.message;
        });
      },
      getCategoriesForOrder: function(){
        return this.$http
          .get(this.$store.getters.backendurl + 'api/v1/categories/')
          .then(function(response){
            return response.data || [];
          });
      },
      putCategoriesOrder: function(categoryIds){
        return this.$http.put(
          this.$store.getters.backendurl + 'api/v1/categories/order',
          { category_ids: categoryIds }
        );
      },
      postCategory: function(){
        var that = this;
        this.$http.post(this.$store.getters.backendurl + 'api/v1/categories', 
        this.category
        )
        .then(function (response) {
            //Obtener ID de la tarea recién creada y pasar a la vista de asignar usuarios
            let idCategory= response.data.id
            that.$router.push('/capas/categorias-de-capas/'+ idCategory)
        })
        .catch(function (error) {
            console.log(error);
        });
      },
      putCategory: function(){
        var that = this;
        this.$http.put(this.$store.getters.backendurl + 'api/v1/categories/' + this.$route.params.idCategory,
        this.category
        )
        .then(function (response) {
            that.$router.push('/capas/categorias-de-capas/'+ that.$route.params.idCategory)
        })
        .catch(function (error) {
            console.log(error)
            that.message = error.response.data.message;
        });
      },
      deleteCategory: function(){
        var that = this;
        this.$http.delete(this.$store.getters.backendurl + 'api/v1/categories/' + this.$route.params.idCategory)
        .then(function (response) {
            that.$router.push('/capas/categorias-de-capas/')
        })
        .catch(function (error) {
            console.log(error)
            that.message = error.response.data.message;
        });
      },
    }
  }
